import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Footer = () => {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-terminal-box-line text-background-50 text-lg"></i>
              </div>
              <span className="text-base font-semibold text-foreground-950 whitespace-nowrap">
                草榴社区技术讨论区
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              专业的技术交流与资源分享平台，汇聚编程、网络安全、人工智能等技术话题，助力技术人员快速成长。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="GitHub">
                <i className="ri-github-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微博">
                <i className="ri-weibo-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="RSS">
                <i className="ri-rss-fill text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">技术分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/category/programming" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">热门文章</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">加入社区</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">意见反馈</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                <span>contact@techcommunity.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                <span>北京市海淀区中关村科技园</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-time-line text-primary-500 mt-0.5"></i>
                <span>周一至周五 9:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 草榴社区技术讨论区. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;